import React from "react";
import dateformat from "dateformat";
import { AnalyticsCard, AnalyticsTable, Cell, ColumnDef, TableFooter } from "../../common";
import { useJourneyReportsQuery } from "src/query/experiences/leadsAndReports/reports";
import { useTableState } from "../../hooks/useTableState";

interface JourneyAnalyticsProps {
  storyboardId: string;
}

const COLUMNS: ColumnDef[] = [
  { key: "name", header: "Journey Name" },
  { key: "created", header: "Date of creation", align: "right" },
  { key: "views", header: "Views", align: "right" },
  { key: "visitors", header: "Visitors", align: "right" },
  { key: "leads", header: "Leads", align: "right" },
  { key: "completion", header: "Avg Completion %", align: "right" },
];

export const JourneyAnalytics: React.FC<JourneyAnalyticsProps> = ({ storyboardId }) => {
  const { request, key, page, setPage, chart, enabled } = useTableState(storyboardId);
  const { data, isLoading } = useJourneyReportsQuery(request, key, page, enabled);
  const rows = data?.records ?? [];

  return (
    <AnalyticsCard
      title="Journey Analytics"
      count={data?.totalRecordsCount ?? rows.length}
      footer={
        <TableFooter
          currentChart={chart}
          handlePageChange={setPage}
          pagination={data}
          paginationName="Journeys"
        />
      }
    >
      <AnalyticsTable
        columns={COLUMNS}
        rows={rows}
        loading={isLoading}
        renderRow={(row: any) => (
          <>
            <Cell headline={row.name} />
            <Cell headline={dateformat(row.createdDate, "dd mmm yyyy")} />
            <Cell headline={row.views} />
            <Cell headline={row.visitors} />
            <Cell headline={row.leads} />
            <Cell headline={`${row.completion}%`} />
          </>
        )}
      />
    </AnalyticsCard>
  );
};
